import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className=" max-w-screen-2xl  hedvig-letters-sans-regular bg-white mx-auto my-32">
      <h2 className="text-black text-5xl lg:text-5xl xl:text-7xl hedvig-letters-serif-regular text-center">
        Privacy Policy
      </h2>
      <p>
        <strong>Effective Date:</strong> 11/07/2024
      </p>
      <p>
        All in 1 (&quot;we,&quot; &quot;our,&quot; &quot;us&quot;) is committed
        to protecting your privacy and complying with the Australian Privacy
        Principles (APPs) set out in the Privacy Act 1988 (Cth). This Privacy
        Policy outlines how we collect, use, disclose, and safeguard your
        personal information when you visit our website{' '}
        <a href="http://www.allin1.com.au">www.allin1.com.au</a>, and how you
        can contact us with privacy-related concerns.
      </p>

      <h3 className="text-black text-2xl hedvig-letters-serif-regular">
        1. Collection of Personal Information
      </h3>
      <p>
        We may collect personal information about you in various ways, including
        when you provide it to us directly or when we collect it automatically
        through your use of our website. The types of personal information we
        may collect include:
      </p>
      <ul>
        <li>Name</li>
        <li>Contact details (&quot;e.g.,&quot; email address, phone number)</li>
        <li>Address</li>
        <li>Other information you voluntarily provide to us</li>
      </ul>

      <h3 className="text-black text-2xl hedvig-letters-serif-regular">
        2. Use of Personal Information
      </h3>
      <p>
        We collect and use personal information primarily for the following
        purposes:
      </p>
      <ul>
        <li>To provide and manage our products and services</li>
        <li>
          To communicate with you, including responding to your inquiries and
          providing customer support
        </li>
        <li>To personalize and improve our website and services</li>
        <li>To comply with our legal obligations</li>
      </ul>

      <h3 className="text-black text-2xl hedvig-letters-serif-regular">
        3. Disclosure of Personal Information
      </h3>
      <p>
        We may disclose your personal information to third parties in the
        following circumstances:
      </p>
      <ul>
        <li>With your consent or as otherwise required or permitted by law</li>
        <li>
          To service providers who assist us in operating our business
          (&quot;e.g.,&quot; IT service providers, payment processors)
        </li>
        <li>
          When we believe disclosure is necessary to protect our rights,
          property, or safety, or that of others
        </li>
      </ul>

      <h3 className="text-black text-2xl hedvig-letters-serif-regular">
        {' '}
        4. Security of Personal Information
      </h3>
      <p>
        We take reasonable steps to protect the personal information we hold
        from misuse, interference, loss, unauthorized access, modification, or
        disclosure. These measures include physical, technological, and
        administrative security safeguards.
      </p>

      <h3 className="text-black text-2xl hedvig-letters-serif-regular">
        5. Access and Correction
      </h3>
      <p>
        You may request access to the personal information we hold about you,
        and request corrections if necessary. We will respond to such requests
        in accordance with the APPs.
      </p>

      <h3 className="text-black text-2xl hedvig-letters-serif-regular">
        6. Complaints
      </h3>
      <p>
        If you have a complaint about how we have handled your personal
        information, please contact us using the details provided below. We will
        investigate your complaint promptly and respond to you in writing.
      </p>

      <h3 className="text-black text-2xl hedvig-letters-serif-regular">
        7. Changes to This Privacy Policy
      </h3>
      <p>
        We may update this Privacy Policy from time to time to reflect changes
        in our practices and legal requirements. We encourage you to review this
        Privacy Policy periodically for any updates. We will notify you of any
        material changes by posting the updated Privacy Policy on our website.
      </p>

      <h3>Contact Us</h3>
      <p>
        If you have any questions about this Privacy Policy or our privacy
        practices, or to exercise your rights regarding your personal
        information, please contact us at:
      </p>
      <ul>
        <li>
          Email: <a href="mailto:sales@allin1.com.au">sales@allin1.com.au</a>
        </li>
        <li>
          Phone: <a href="tel:+61404431431">0404 431 431</a>
        </li>
        <li>
          Website: <a href="http://www.allin1.com.au">www.allin1.com.au</a>
        </li>
      </ul>
    </div>
  );
};

export default PrivacyPolicy;
